







































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import TestPaper from "@/store/entities/testPaper";
import url from "@/lib/url";
//import ewebeditor from "@/components/ewebeditor.vue";

@Component({
  components: {},
})
export default class EditTestPaper extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  testPaper: TestPaper = new TestPaper();

  editorConfig: any = {
    style: "coolblue",
    width: "100%",
    height: "200px",
  };
  frontendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  editorBackendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  formTitle: string = "作业修改";
  isCreate: boolean = true;
  data: any = [];
  valueArray: any = [];
  screenWidth: number = document.body.clientWidth - 200;
  questioncount: number = 0;
  questnumlist: string =
    "qTypeA0AstndA1,qTypeA0AstndA2,qTypeA0AstndA3,qTypeA1AstndA1,qTypeA1AstndA2,qTypeA1AstndA3,qTypeA2AstndA1,qTypeA2AstndA2,qTypeA2AstndA3,qTypeA3AstndA1,qTypeA3AstndA2,qTypeA3AstndA3,qTypeA4AstndA1,qTypeA4AstndA2,qTypeA4AstndA3,qTypeA8AstndA1,qTypeA8AstndA2,qTypeA8AstndA3,qTypeA9AstndA1,qTypeA9AstndA2,qTypeA9AstndA3,qTypeA10AstndA1,qTypeA10AstndA2,qTypeA10AstndA3,qTypeA11AstndA1,qTypeA11AstndA2,qTypeA11AstndA3,qTypeA12AstndA1,qTypeA12AstndA2,qTypeA12AstndA3,qTypeA7AstndA1,qTypeA7AstndA2,qTypeA7AstndA3,qTypeA5AstndA1,qTypeA5AstndA2,qTypeA5AstndA3,qTypeA6AstndA1,qTypeA6AstndA2,qTypeA6AstndA3";
  questfenlist: string =
    "fenAqTypeA0AstndA1,fenAqTypeA0AstndA2,fenAqTypeA0AstndA3,fenAqTypeA1AstndA1,fenAqTypeA1AstndA2,fenAqTypeA1AstndA3,fenAqTypeA2AstndA1,fenAqTypeA2AstndA2,fenAqTypeA2AstndA3,fenAqTypeA3AstndA1,fenAqTypeA3AstndA2,fenAqTypeA3AstndA3,fenAqTypeA4AstndA1,fenAqTypeA4AstndA2,fenAqTypeA4AstndA3,fenAqTypeA8AstndA1,fenAqTypeA8AstndA2,fenAqTypeA8AstndA3,fenAqTypeA9AstndA1,fenAqTypeA9AstndA2,fenAqTypeA9AstndA3,fenAqTypeA10AstndA1,fenAqTypeA10AstndA2,fenAqTypeA10AstndA3,fenAqTypeA11AstndA1,fenAqTypeA11AstndA2,fenAqTypeA11AstndA3,fenAqTypeA12AstndA1,fenAqTypeA12AstndA2,fenAqTypeA12AstndA3,fenAqTypeA7AstndA1,fenAqTypeA7AstndA2,fenAqTypeA7AstndA3,fenAqTypeA5AstndA1,fenAqTypeA5AstndA2,fenAqTypeA5AstndA3,fenAqTypeA6AstndA1,fenAqTypeA6AstndA2,fenAqTypeA6AstndA3";
  questchek: any = {
    fenAqTypeA0AstndA1: "",
    fenAqTypeA0AstndA2: "",
    fenAqTypeA0AstndA3: "",
    fenAqTypeA1AstndA1: "",
    fenAqTypeA1AstndA2: "",
    fenAqTypeA1AstndA3: "",
    fenAqTypeA2AstndA1: "",
    fenAqTypeA2AstndA2: "",
    fenAqTypeA2AstndA3: "",
    fenAqTypeA3AstndA1: "",
    fenAqTypeA3AstndA2: "",
    fenAqTypeA3AstndA3: "",
    fenAqTypeA4AstndA1: "",
    fenAqTypeA4AstndA2: "",
    fenAqTypeA4AstndA3: "",
    fenAqTypeA8AstndA1: "",
    fenAqTypeA8AstndA2: "",
    fenAqTypeA8AstndA3: "",
    fenAqTypeA9AstndA1: "",
    fenAqTypeA9AstndA2: "",
    fenAqTypeA9AstndA3: "",
    fenAqTypeA10AstndA1: "",
    fenAqTypeA10AstndA2: "",
    fenAqTypeA10AstndA3: "",
    fenAqTypeA11AstndA1: "",
    fenAqTypeA11AstndA2: "",
    fenAqTypeA11AstndA3: "",
    fenAqTypeA12AstndA1: "",
    fenAqTypeA12AstndA2: "",
    fenAqTypeA12AstndA3: "",
    fenAqTypeA7AstndA1: "",
    fenAqTypeA7AstndA2: "",
    fenAqTypeA7AstndA3: "",
    fenAqTypeA5AstndA1: "",
    fenAqTypeA5AstndA2: "",
    fenAqTypeA5AstndA3: "",
    fenAqTypeA6AstndA1: "",
    fenAqTypeA6AstndA2: "",
    fenAqTypeA6AstndA3: "",
    qTypeA0AstndA1: "",
    qTypeA0AstndA2: "",
    qTypeA0AstndA3: "",
    qTypeA1AstndA1: "",
    qTypeA1AstndA2: "",
    qTypeA1AstndA3: "",
    qTypeA2AstndA1: "",
    qTypeA2AstndA2: "",
    qTypeA2AstndA3: "",
    qTypeA3AstndA1: "",
    qTypeA3AstndA2: "",
    qTypeA3AstndA3: "",
    qTypeA4AstndA1: "",
    qTypeA4AstndA2: "",
    qTypeA4AstndA3: "",
    qTypeA8AstndA1: "",
    qTypeA8AstndA2: "",
    qTypeA8AstndA3: "",
    qTypeA9AstndA1: "",
    qTypeA9AstndA2: "",
    qTypeA9AstndA3: "",
    qTypeA10AstndA1: "",
    qTypeA10AstndA2: "",
    qTypeA10AstndA3: "",
    qTypeA11AstndA1: "",
    qTypeA11AstndA2: "",
    qTypeA11AstndA3: "",
    qTypeA12AstndA1: "",
    qTypeA12AstndA2: "",
    qTypeA12AstndA3: "",
    qTypeA7AstndA1: "",
    qTypeA7AstndA2: "",
    qTypeA7AstndA3: "",
    qTypeA5AstndA1: "",
    qTypeA5AstndA2: "",
    qTypeA5AstndA3: "",
    qTypeA6AstndA1: "",
    qTypeA6AstndA2: "",
    qTypeA6AstndA3: "",
  };
  questiontypelist: any = [
    {
      name: "判断题",
      list: [
        {
          id: "qTypeA0AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA0AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA0AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA0AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA0AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA0AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "单选题",
      list: [
        {
          id: "qTypeA1AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA1AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA1AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA1AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA1AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA1AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "多选题",
      list: [
        {
          id: "qTypeA2AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA2AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA2AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA2AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA2AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA2AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "填空题",
      list: [
        {
          id: "qTypeA3AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA3AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA3AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA3AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA3AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA3AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "计算题",
      list: [
        {
          id: "qTypeA4AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA4AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA4AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA4AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA4AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA4AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },

    {
      name: "解答题",
      list: [
        {
          id: "qTypeA8AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA8AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA8AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA8AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA8AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA8AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "作文题",
      list: [
        {
          id: "qTypeA9AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA9AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA9AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA9AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA9AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA9AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "探究题",
      list: [
        {
          id: "qTypeA10AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA10AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA10AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA10AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA10AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA10AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "材料题",
      list: [
        {
          id: "qTypeA11AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA11AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA11AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA11AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA11AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA11AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "实践题",
      list: [
        {
          id: "qTypeA12AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA12AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA12AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA12AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA12AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA12AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "选考单选",
      list: [
        {
          id: "qTypeA7AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA7AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA7AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA7AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA7AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA7AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "选考多选",
      list: [
        {
          id: "qTypeA5AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA5AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA5AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA5AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA5AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA5AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "选考计算",
      list: [
        {
          id: "qTypeA6AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA6AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA6AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA6AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA6AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA6AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
  ];

  get isGeneral() {
    return sessionStorage.getItem("isGeneral") == "true" ? 1 : 0;
  }
  // setEditorData() {
  //   (this.$refs["editewe"] as any).setHtmleweb(this.testpaperdescription);
  // }
  numValid(val, id, ctype) {
    /**  if (!this.testPaper.totalQuestion) {
      this.$Message.warning("请先输入试题总数");
      this.$nextTick(() => {
        this.questchek[id] = "";
      });
      return false;
    }
    if (!this.testPaper.totalFraction) {
      this.$Message.warning("请先输入试卷总分");
      this.$nextTick(() => {
        this.questchek[id] = "";
      });
      return false;
    }
 */
    var reg = /(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/;

    if (val != "" && val != undefined) {
      if (!reg.test(val)) {
        this.$Message.warning("只能输入正整数");
        this.$nextTick(() => {
          this.questchek[id] = "";
        });
        return false;
      } else {
        this.questchek[id] = val;
        /** 
        if (ctype == 1) {
          if (val > this.testPaper.totalQuestion) {
            this.questchek[id] = "";
            return false;
          } else {
            this.questchek[id] = val;
          }
        } else {
          if (val > this.testPaper.totalFraction) {
            this.questchek[id] = "";
            return false;
          } else {
            this.questchek[id] = val;
          }
        }*/
      }
    }

    //FtestPaper totalQuestion

    this.questioncount = this.testquestioncount();
    let fractions = this.testquestionsfencount();
    /*if (this.questioncount > this.testPaper.totalQuestion) {
      this.$Message.warning("输入的试题数量已经超过试题总数");
      this.$nextTick(() => {
        this.questchek[id] = "";
      });
      return false;
    } else {
      this.totalQuestions = this.testPaper.totalQuestion - this.questioncount;
    }*/
    this.testPaper.totalQuestion = this.questioncount;
    let questionfencount = this.testquestionfencount();
    /** if (ctype == 2) {
      if (Number(this.testquestionfencount()) > this.testPaper.totalFraction) {
        this.$Message.warning("输入的试题分数已经超过试题总分数");
        this.$nextTick(() => {
          this.questchek[id] = "";
          return false;
        });
      } else {
        this.totalFractions = this.testPaper.totalFraction - questionfencount;
      }
    } */
    this.testPaper.totalFraction = this.testquestionsfencount();
    /** if (Number(this.testquestionsfencount()) > this.testPaper.totalFraction) {
      this.$Message.warning("输入的试题分数相加，已经超过试卷总分");
      this.$nextTick(() => {
        this.questchek[id] = "";
        return false;
      });
    } else {
      this.totalFractions = this.testPaper.totalFraction - fractions;
    } */
  }
  testquestioncount() {
    let idlist = this.questnumlist.split(",");
    let sum = 0;
    for (var i = 0; i < idlist.length; i++) {
      sum += Number(this.questchek[idlist[i]]);
    }
    return sum;
  }

  testquestionfencount() {
    let qidlist = this.questfenlist.split(",");
    let _this = this;
    let sum = 0;
    for (var i = 0; i < qidlist.length; i++) {
      sum += Number(_this.questchek[qidlist[i]]);
    }

    return sum;
  }
  testquestionsfencount() {
    let question_fencount = 0;
    let idlist = this.questnumlist.split(",");
    let qidlist = this.questfenlist.split(",");
    let inputvalue;
    let qinputvalue;
    for (var i = 0; i < idlist.length; i++) {
      inputvalue = this.questchek[idlist[i]];
      qinputvalue = this.questchek[qidlist[i]];
      question_fencount += Number(inputvalue) * Number(qinputvalue);
    }
    return question_fencount;
  }
  cascaderSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.testPaper.sectionId = selectedData[selectedData.length - 1].id;
    else this.testPaper.sectionId = null;
  }
  questionTypeAndAmount() {
    this.testPaper.questionTypeAndAmount = "";
    let idlist = this.questnumlist.split(",");
    for (var i = 0; i < idlist.length; i++) {
      let questionNum = this.questchek[idlist[i]];
      questionNum = questionNum > 0 ? questionNum : 0;
      if (!this.testPaper.questionTypeAndAmount)
        this.testPaper.questionTypeAndAmount = idlist[i] + "," + questionNum;
      else
        this.testPaper.questionTypeAndAmount +=
          "|" + idlist[i] + "," + questionNum;
    }
  }
  questionTypeAndFraction() {
    this.testPaper.questionTypeAndFraction = "";
    // let question_fencount = 0;
    let idlist = this.questnumlist.split(",");
    let qidlist = this.questfenlist.split(",");
    // let inputvalue;
    let qinputvalue;
    for (var i = 0; i < idlist.length; i++) {
      // inputvalue = Number(this.questchek[idlist[i]]);
      qinputvalue = Number(this.questchek[qidlist[i]]);
      // question_fencount = Number(inputvalue) * Number(qinputvalue);
      if (!this.testPaper.questionTypeAndFraction)
        this.testPaper.questionTypeAndFraction = qidlist[i] + "," + qinputvalue;
      else
        this.testPaper.questionTypeAndFraction +=
          "|" + qidlist[i] + "," + qinputvalue;
    }
  }
  save() {
    (this.$refs.testPaperForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.questionTypeAndAmount();
        this.questionTypeAndFraction();
        await this.$store.dispatch({
          type: "testPaper/update",
          data: this.testPaper,
        });
        //  (this.$refs.testPaperForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    this.data = this.$store.state.testPaper.cascaders.items;
    if (!value) {
      this.testPaper = new TestPaper();
      this.$store.state.testPaper.editTestPaper = this.testPaper;
      (this.$refs.testPaperForm as any).resetFields();
      this.$emit("input", value);
    } else {
      this.testPaper = Util.extend(
        true,
        {},
        this.$store.state.testPaper.editTestPaper,
      );
      if (this.testPaper.id) {
        const infofen =
          this.testPaper.questionTypeAndFraction +
          "|" +
          this.testPaper.questionTypeAndAmount;
        const newinfofen = infofen.replace(/_/g, "A");
        let obj = {};
        let parts = newinfofen.split("|");
        parts.forEach((part) => {
          let subParts = part.split(",");
          obj[subParts[0]] = parseInt(subParts[1]);
        });
        this.questchek = obj;
        this.isCreate = false;
        this.formTitle = "试卷修改";
        this.valueArray = this.$store.state.testPaper.editTestPaper.categoryList;
      }
    }
  }

  testPaperRule = {
    name: [
      {
        required: true,
        message: this.L("该项不能为空", undefined, "试卷名称"),
        trigger: "blur",
      },
      {
        type: "string",
        min: 2,
        max: 200,
        message: "试卷名称为2-200个字符",
        trigger: "blur",
      },
    ],
  };
}
